module.exports = __webpack_public_path__ + "assets/mobile_back-cde8be.svg";